package com.essntl.features.itinerary.ui.edit_itinerary.components

import androidx.compose.foundation.background
import androidx.compose.foundation.layout.*
import androidx.compose.foundation.shape.RoundedCornerShape
import androidx.compose.material3.MaterialTheme
import androidx.compose.runtime.Composable
import androidx.compose.ui.Alignment
import androidx.compose.ui.Modifier
import androidx.compose.ui.draw.clip
import com.essntl.features.itinerary.domain.model.ItineraryServiceModel
import com.essntl.features.itinerary.ui.edit_itinerary.EditItineraryEvent
import com.essntl.uikit.components.button.primary.EsSmallPrimaryButton
import com.essntl.uikit.components.checkbox.EsCheckBoxState
import com.essntl.uikit.components.icons.EsIcons
import com.essntl.uikit.components.utils.EsConstants
import com.essntl.uikit.components.utils.EsRowDefaultItem
import com.essntl.uikit.theme.esColorScheme
import core.config.FeatureConfig


@Composable
fun ColumnScope.HeaderTitles(
    onEvent: (EditItineraryEvent) -> Unit,
    onAddServiceClick: () -> Unit,
    itineraryServices: List<ItineraryServiceModel>,
    selectedItineraryServiceList: List<ItineraryServiceModel>,
    isConcierge: Boolean,
) {
    Row(
        verticalAlignment = Alignment.CenterVertically,
        modifier = Modifier
            .fillMaxWidth()
            .clip(RoundedCornerShape(EsConstants.RoundedCornerSize))
            .background(MaterialTheme.esColorScheme.bgSecondary)
            .padding(
                vertical = EsConstants.ListRowVerticalPadding,
                horizontal = EsConstants.ListRowHorizontalPadding + EsConstants.SectionHorizontalPadding,
            )
            .height(EsConstants.ListColumnHeaderHeight),
    ) {
        // Service information
        EsRowDefaultItem(
            text = "Service",
            spacedContent = {
                if (!isConcierge)
                    EsSmallPrimaryButton(
                        onClick = onAddServiceClick,
                        text = "Add",
                        prefixIconRes = EsIcons.Add,
                    )
            },
            isFirst = true,
            showsCheckBox = true,
            checkBoxState = when {
                selectedItineraryServiceList.size == itineraryServices.size ->
                    EsCheckBoxState.Checked

                selectedItineraryServiceList.isNotEmpty() ->
                    EsCheckBoxState.Indeterminate

                else ->
                    EsCheckBoxState.Unchecked
            },
            onCheckboxClicked = {
                onEvent(EditItineraryEvent.SelectAllItineraryService)
            },
            weight = 2f,
        )

        if (isConcierge) {
            // Traveller
            EsRowDefaultItem(
                text = "Traveller",
            )
        }

        if (FeatureConfig.hasWhatsapp)
        // Message
            EsRowDefaultItem(
                text = "Message",
            )

        // Status
        EsRowDefaultItem(
            text = "Status",
        )

        if (!isConcierge)
        // Dates
            EsRowDefaultItem(
                text = "Dates",
            )

        // Time
        EsRowDefaultItem(
            text = "Time",
        )

        // Tasks
        EsRowDefaultItem(
            text = if (isConcierge) "Tasks" else {
                "Service Tasks"
            },
        )

        // # Pax
        EsRowDefaultItem(
            text = "# Pax",
        )

        if (isConcierge) {
            // TA
            EsRowDefaultItem(
                text = "Travel Agent",
            )
        }
    }
}